import React from 'react'
import '@material/web/button/tonal-button.js';
import { ThemeContext } from '../../theme/DarkMode';
import Fade from 'react-reveal/Fade';
import { useTranslation } from 'react-i18next';
import emailjs from '@emailjs/browser';
import { LineWobble } from '@uiball/loaders'
import DoneAllIcon from '@mui/icons-material/DoneAll';
import EmailIcon from '@mui/icons-material/Email';

export const Contact = () => {

    const { theme } = React.useContext(ThemeContext)
    const [buttonState, setButtonState] = React.useState(0)
    const inputRef = React.useRef()
    const form = React.useRef()

    const { t } = useTranslation()

    const sendEmail = (e) => {
        e.preventDefault();
        setButtonState(1)

        const templateParams = {
            to_email: 'ahil.app.sup@gmail.com',
            from_name: 'Ahil Website Contact',
            message: form.current.message.value
        };

        emailjs.send('service_ei7x21f', 'template_boqs2wc', templateParams, 'fUrSqTFVtYzqIgraD')
            .then((result) => {
                console.log(result.text);
                inputRef.current.value = ''
                setButtonState(2)
                setTimeout(() => {
                    setButtonState(0)
                }, 10000);
            }, (error) => {
                console.log(error.text);
                setButtonState(3)
                setTimeout(() => {
                    setButtonState(0)
                }, 10000);
            });
    }

    return (
        <Fade bottom>
            <article className='contact-wrapper'>
                <h1 className={theme === 'light' ? 'light-title' : 'title'}>{t('contact.header')}</h1>
                <form className='email-btn-wraaper' onSubmit={sendEmail} ref={form}>
                    <input placeholder={t('contact.placeHolder')} className={theme === 'light' ? 'light-input' : 'input'} ref={inputRef} name="message" autoComplete='false' required />
                    <div className='send-button'>
                        {buttonState === 0 ?
                            <md-tonal-button type='submit'>
                                {t('contact.sendButton')}
                                <EmailIcon sx={{ marginBottom: '-4px', marginLeft: '5px', marginRight: '5px', fontSize: '22px' }} />
                            </md-tonal-button>
                            : buttonState === 1 ?
                                <md-tonal-button>
                                    <LineWobble
                                        size={64}
                                        lineWeight={3}
                                        speed={1.75}
                                        color="white"
                                    />
                                </md-tonal-button>
                                : buttonState === 2 ?
                                    <md-tonal-button>
                                        {t('contact.sentText')}
                                        <DoneAllIcon sx={{ marginBottom: '-5px', marginLeft: '5px', marginRight: '5px', fontSize: '22px' }} />
                                    </md-tonal-button>
                                    :
                                    <md-tonal-button>
                                        {t('contact.errorText')}
                                    </md-tonal-button>
                        }
                    </div>
                </form>
            </article>
        </Fade>
    )
}
